import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class DesignerRating extends React.Component {
    noReviews() {
        return (
            <div>
                <FormattedMessage id="review_summary_none" />
            </div>
        );
    }

    reviewsWithNoStars() {
        let messageId = 'review_summary_count';

        if (this.props.review.count == 1) {
            messageId = 'review_summary_count_single';
        }

        return (
            <a href={this.props.reviewUrl} className="link">
                <FormattedMessage
                    id={messageId}
                    values={{ reviewCount: this.props.review.count }}
                />
            </a>
        );
    }

    reviewsAndStars() {
        return (
            <a href={this.props.reviewUrl} className="link">
                <FormattedMessage
                    id="review_star_summary_count"
                    values={{
                        starRating: this.props.review.rating,
                        reviewCount: this.props.review.count,
                    }}
                />
            </a>
        );
    }

    render() {
        let reviewText = null;

        if (this.props.review.count < 1) {
            reviewText = this.noReviews();
        } else {
            if (this.props.review.rating && this.props.review.count > 4) {
                reviewText = this.reviewsAndStars();
            } else {
                reviewText = this.reviewsWithNoStars();
            }
        }

        return <div className="subtle-text">{reviewText}</div>;
    }
}

DesignerRating.propTypes = {
    reviewUrl: PropTypes.string.isRequired,
    review: PropTypes.shape({
        rating: PropTypes.number,
        count: PropTypes.number,
    }).isRequired,
};

export default DesignerRating;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerRating.jsx